import { vmMachineExtraServiceConf } from '@/constant/config.js';
import axios from "axios";
const queryString = require('query-string');
export default {
    getElementsList(requestParam) {
        let queryParams = queryString.stringify(requestParam);
        return axios({
            method: "GET",
            url: `${vmMachineExtraServiceConf.listExtraServices}?${queryParams}`,
            withCredentials: true,
        });
    },
    getExtraServices(id) {
        return axios({
            method: "GET",
            url: `${vmMachineExtraServiceConf.getExtraServices.format(id)}`,
            withCredentials: true,
        });
    },
    markedDone(id) {
        return axios({
            method: "GET",
            url: `${vmMachineExtraServiceConf.markedDone.format(id)}`,
            withCredentials: true,
        });
    },
    markedDenied(id) {
        return axios({
            method: "GET",
            url: `${vmMachineExtraServiceConf.markedDenied.format(id)}`,
            withCredentials: true,
        });
    },
    removeExtraServices(id) {
        return axios({
            method: "GET",
            url: `${vmMachineExtraServiceConf.removeExtraServices.format(id)}`,
            withCredentials: true,
        });
    },
};
